"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import $ from "jquery";
import _ from "underscore";
import FactorBrokersStore from "../stores/factor_brokers_store";
const store = FactorBrokersStore;
class FactorBrokersService {
  constructor() {
    __publicField(this, "getFetchedWithId", (id) => store.index[id]);
  }
  getWithId(id) {
    var existing = store.index[id];
    if (id) {
      if (existing) {
        return Promise.resolve(store.index[id]);
      } else {
        return this.fetchWithID(id);
      }
    } else {
      return Promise.resolve(null);
    }
  }
  fetchWithID(id) {
    return Promise.resolve().then(function() {
      return $.get("/api/factor_brokers/" + id).then(function(data) {
        FactorBrokersStore.addOrUpdate(data.factor_broker);
        return store.index[id];
      });
    });
  }
  search(term, silo) {
    return $.get("/api/factor_brokers", {
      page: 1,
      term,
      silo
    }).then(function(data) {
      return data.factor_brokers;
    }, _.identity);
  }
}
var factorBrokersService = new FactorBrokersService();
export default factorBrokersService;
